import { ActionIcon } from "PFComponents/action_icon";
import InputFieldSet from "PFComponents/text/input_field_set";
import { Typography } from "PFComponents/typography";
import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { CalendarForm } from "../../../../calendars.types";
import css from "../../dates.module.scss";

type CustomDayOffLabelProps = {
  index: number;
};

export const CustomDayOffLabel = ({ index }: CustomDayOffLabelProps): JSX.Element => {
  const [editMode, setEditMode] = useState(false);
  const toggleEditMode = () => setEditMode(!editMode);
  const { getValues, control } = useFormContext<CalendarForm>();
  return (
    <div className={css.exceptionDayLabelContainer}>
      <div className={css.exceptionDayLabelWrapper}>
        {editMode ? (
          <Controller
            control={control}
            name={`exceptionDays.${index}.name`}
            render={({ field }) => (
              <InputFieldSet
                inputType={"text"}
                {...field}
                handleChange={field.onChange}
                handleBlur={field.onBlur}
              />
            )}
          />
        ) : (
          <Typography variant="bodyBold" tag="span">
            {getValues(`exceptionDays.${index}.name`)}
          </Typography>
        )}
      </div>
      <ActionIcon name={editMode ? "check" : "edit"} onClick={toggleEditMode} />
    </div>
  );
};
